import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  toolbar: theme.mixins.toolbar,
  layoutWrapper: {
    // ------------ the background of the form until payment
    //background: "green",

    width: "100vw",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    flexDirection: "row",
    //
    [theme.breakpoints.down("xs")]: {
      // backgroundColor: "yellow",

      justifyContent: "center",
      flexDirection: "column",
    },
    [theme.breakpoints.up("sm")]: {
      // backgroundColor: "red",
    },
    [theme.breakpoints.up("md")]: {
      // backgroundColor: "purple",
    },
    [theme.breakpoints.up("lg")]: {
      // backgroundColor: "purple",
    },
  },
  containerFormCheckout: {
    background: "white",
    width: "600px",
    minWidth: "400px",

    padding: "2rem",
    overflow: "hidden",
    //

    boxShadow: "-13px -13px 0px -4px rgba(0, 0, 0, 0.75)",
    border: "4px solid #121212",
    borderRadius: "111px 111px 111px 111px",
    color: "#fff",

    //
    //

    [theme.breakpoints.down("xs")]: {
      // backgroundColor: "yellow",
      padding: "2rem 1rem",
      minWidth: "280px",
      minHeight: "120vh",
      width: "100%",
    },
  },
  // *** ------ the FORM -------
  //

  //
  paper: {
    padding: "2rem 1rem",
    boxShadow: "none",
    backgroundColor: "white",
    [theme.breakpoints.down("xs")]: {
      // backgroundColor: "yellow",
      padding: "3rem 0.4rem",
    },
  },
  //
  // STEPPER *** FORM
  //
  // The stepper is the progress
  // until payment, you see this under the Checkout title
  stepper: {
    display: "flex",
    justifyContent: "space-between",
    flexFlow: "row wrap",
    alignItems: "center",
    // justifyContent: "space-between",
    // flexDirection: "row",
    // alignItems: "center",
    marginTop: "20px",

    //
    backgroundColor: "transparent",
    padding: theme.spacing(3, 0, 5),
  },
  stepLabel: {
    color: "#121212",
  },

  //
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  divider: {
    margin: "20px 0",
  },
  spinner: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));
